// extracted by mini-css-extract-plugin
module.exports = {"scannedTable":"BookingScannedTable_scannedTable__WhQhQ","noData":"BookingScannedTable_noData__rngZl"};